import images from 'assets/images';
import React, { ReactNode } from 'react';
import { Moment } from 'moment';
import { FormattedMessage } from 'react-intl';

export type TileProps = {
	title: string | ReactNode;
	playerAvatar?: string | null;
	playerName?: string | null;
	dateFrom: Moment;
	dateTo: Moment;
	text: string | ReactNode;
	icon: string;
};

export const Tile = ({ title, playerAvatar, playerName, icon, text, dateFrom, dateTo }: TileProps) => {
	return (
		<div className="col-24 col-md-8 mb-4 mb-sm-5">
			<div className="tile battles-hof__tile fs-4 rounded h-100 p-3 d-flex flex-column">
				<div className="battles-hof__tile__inner rounded d-flex flex-column py-4 px-3 py-md-5 px-md-5">
					<div className="text-center font-weight-bold fs-4 fs-md-5">{title}</div>
					<div>
						<div
							className="tile__image rounded-circle background-image size--cover"
							style={{
								backgroundImage: `url(${playerAvatar || images.default.avatar.user})`,
							}}
							title={playerName || ''}
						/>
					</div>
					<div className="tile__player-name text-center font-weight-bold fs-5 fs-md-7">{playerName}</div>
					<div className="d-flex flex-column">
						<div className="tile__color--gray text-center tile__font-small">
							<FormattedMessage
								id={`battle-hof.tile.date`}
								values={{
									dateFrom: <strong>{dateFrom.format('DD.MM.YYYY')}</strong>,
									dateTo: <strong>{dateTo.format('DD.MM.YYYY')}</strong>,
								}}
							/>
						</div>
						<div className="mt-2 text-center font-weight-bolder">{text}</div>
					</div>
				</div>

				<div className="mt-3 mt-md-5 d-flex justify--center">
					<img src={icon} alt="icon" />
				</div>
			</div>
		</div>
	);
};
